export function isDefined(val) {
    return typeof val !== "undefined" && val !== null;
}
